import { render, staticRenderFns } from "./evaluacion-consejo.vue?vue&type=template&id=0b9aaf3c&scoped=true&"
import script from "./evaluacion-consejo.component.ts?vue&type=script&lang=ts&"
export * from "./evaluacion-consejo.component.ts?vue&type=script&lang=ts&"
import style0 from "./evaluacion-consejo.vue?vue&type=style&index=0&id=0b9aaf3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9aaf3c",
  null
  
)

export default component.exports